import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page404.page.',
  templateUrl: './page404.page.component.html',
  styleUrls: ['./page404.page.component.sass'],
})
export class Page404PageComponent implements OnInit {
  constructor() {
    /* */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    //
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */
}
